import { render, staticRenderFns } from "./PackingPerStaff.vue?vue&type=template&id=0f9a6890&scoped=true"
import script from "./PackingPerStaff.vue?vue&type=script&lang=js"
export * from "./PackingPerStaff.vue?vue&type=script&lang=js"
import style0 from "./PackingPerStaff.vue?vue&type=style&index=0&id=0f9a6890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a6890",
  null
  
)

export default component.exports